import {
  GetProductAuthQueryVariables,
  GetProductAuthQuery,
} from '@/appsync/graphql/authQuery';
import {
  graphqlQuery,
  productAdditionalQueryMap,
} from '@/appsync/service/GraphqlUtils';
import { TenantLandscape, ProductAdditionalQueryMap } from '@/types/type';

export interface AuthQueryParam extends TenantLandscape {
  identityProvider: string;
}

export const fetchAuthQuery = async (
  param: AuthQueryParam
): Promise<ProductAdditionalQueryMap> => {
  const variables: GetProductAuthQueryVariables = {
    tenant: param.tenant,
    landscape: param.landscape,
    identityProvider: param.identityProvider,
  };
  const result = await graphqlQuery<
    GetProductAuthQuery,
    GetProductAuthQueryVariables
  >(getProductAuthQuery, variables);
  const resultMap: ProductAdditionalQueryMap = {};
  return productAdditionalQueryMap(result);
};

export const getProductAuthQuery = /* GraphQL */ `
  query GetProductAuthQuery(
    $tenant: String!
    $landscape: String!
    $identityProvider: String!
  ) {
    authQueryCJK: getAuthQuery(
      tenant: $tenant
      landscape: $landscape
      identityProvider: $identityProvider
      product: CJK
    ) {
      product
      additionalQuery
    }

    authQueryCWS: getAuthQuery(
      tenant: $tenant
      landscape: $landscape
      identityProvider: $identityProvider
      product: CWS
    ) {
      product
      additionalQuery
    }

    authQueryCSR: getAuthQuery(
      tenant: $tenant
      landscape: $landscape
      identityProvider: $identityProvider
      product: CSR
    ) {
      product
      additionalQuery
    }

    authQueryCTM: getAuthQuery(
      tenant: $tenant
      landscape: $landscape
      identityProvider: $identityProvider
      product: CTM
    ) {
      product
      additionalQuery
    }
  }
`;
